'use client';

import { useState } from 'react';
import styles from './Index.module.css';
import LiveHelpWrapper from './LiveHelpWrapper';

const LiveHelp = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className={styles.circle}>
      <LiveHelpWrapper isOpen={isOpen} setIsOpen={setIsOpen} />
      {!isOpen ? (
        <div onClick={() => setIsOpen(!isOpen)} className={styles.center}>
          <span>
            <svg width='40' height='31' viewBox='0 0 40 31' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M15.9712 30.9773C7.28764 30.9773 0.220703 23.8786 0.220703 15.1559C0.220703 13.5321 0.474746 11.9314 0.959732 10.4003L5.07056 12.6505C4.8858 13.4857 4.79343 14.3208 4.79343 15.1791C4.79343 21.3731 9.82804 26.4304 15.9943 26.4304C22.1605 26.4304 27.1951 21.3731 27.1951 15.1791C27.1951 14.344 27.1028 13.4857 26.918 12.6505L31.0288 10.4003C31.5138 11.9314 31.7679 13.5321 31.7679 15.1559C31.7217 23.8786 24.6547 30.9773 15.9712 30.9773Z'
                fill='white'
              />
              <path
                d='M31.0064 10.3538L26.8494 12.6272C27.0341 13.4392 27.1496 14.2975 27.1496 15.1558C27.1496 21.3498 22.1381 26.3839 15.9718 26.3839C9.80558 26.3839 4.79406 21.3498 4.79406 15.1558C4.79406 14.2743 4.88644 13.4392 5.09429 12.6272L0.937271 10.3538C0.452285 11.8617 0.198242 13.4855 0.198242 15.1558C0.198242 23.9016 7.26518 31.0004 15.9718 31.0004C24.6785 31.0004 31.7454 23.9016 31.7454 15.1558C31.7454 13.4855 31.4914 11.8849 31.0064 10.3538ZM30.9833 10.4466C31.4683 11.9776 31.6992 13.5551 31.6992 15.1558C31.6992 23.8552 24.6554 30.954 15.9718 30.954C7.28827 30.954 0.244434 23.8784 0.244434 15.1558C0.244434 13.5551 0.475381 11.9545 0.960367 10.4466L5.02501 12.6736C4.84025 13.5087 4.74787 14.3439 4.74787 15.179C4.74787 21.3962 9.78249 26.4535 15.9718 26.4535C22.1612 26.4535 27.1958 21.3962 27.1958 15.179C27.1958 14.3439 27.1034 13.5087 26.9186 12.6736L30.9833 10.4466Z'
                fill='white'
              />
              <path d='M8.62866 10.3075L18.8365 16.1999L18.5593 16.6639L8.62866 10.3075Z' fill='white' />
              <path
                d='M4.35498 7.70886L18.5812 16.8258L18.9969 16.1531L4.35498 7.70886ZM12.8769 12.9053L18.6505 16.2459L18.4888 16.5011L12.8769 12.9053Z'
                fill='white'
              />
              <path d='M13.0627 16.1994L31.3998 5.36572L13.3399 16.6634L13.0627 16.1994Z' fill='white' />
              <path
                d='M39.0889 0.703003L12.8997 16.1532L13.3154 16.8259L39.0889 0.703003ZM23.7079 10.052L13.3846 16.5243L13.223 16.246L23.7079 10.052Z'
                fill='white'
              />
            </svg>
          </span>
          <p className={styles.text}>Live Help</p>
        </div>
      ) : (
        <div className={styles.close} onClick={() => setIsOpen(!isOpen)}>
          <svg width='18' height='12' viewBox='0 0 18 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M0.65053 3.27611C0.122113 2.75011 0.12015 1.89534 0.646145 1.36692C1.12831 0.882541 1.88673 0.840526 2.4168 1.24204L2.55533 1.36254L9.06843 7.84709L15.6505 1.2938C16.1349 0.811637 16.8935 0.773107 17.4217 1.17705L17.5597 1.29818C18.0419 1.78257 18.0804 2.54118 17.6765 3.0694L17.5553 3.20737L10.0208 10.7074C9.53799 11.188 8.78235 11.228 8.25407 10.8275L8.116 10.7074L0.65053 3.27611Z'
              fill='white'
            />
          </svg>
        </div>
      )}
    </div>
  );
};

export default LiveHelp;
